
import { useState } from "react";
import { Screen } from "@/models/screen";
import { toast } from "sonner";
import { addScreenToSupabase, updateScreenInSupabase, deleteScreenFromSupabase } from "../data/supabaseScreensCrud";

export interface ScreenInput {
  name: string;
  location: string;
  totalSpaces: number;
  occupiedSpaces: number;
}

export const useScreensCrud = (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  refreshData: () => Promise<void>
) => {
  // Modificado: Se asegura de calcular y enviar todos los campos derivados
  const addScreen = async (screenData: ScreenInput) => {
    setIsLoading(true);
    try {
      console.log("Starting to add screen:", screenData);
      
      // Ensure we have proper numeric values
      const totalSpaces = Number(screenData.totalSpaces);
      const occupiedSpaces = Number(screenData.occupiedSpaces);
      
      // Calculate derived values
      const availableSpaces = totalSpaces - occupiedSpaces;
      const occupancyRate = totalSpaces > 0 ? Math.round((occupiedSpaces / totalSpaces) * 100) : 0;

      // Full data to send
      const fullScreenData = {
        name: screenData.name,
        location: screenData.location,
        max_ads: totalSpaces,
        occupied_spaces: occupiedSpaces,
        available_spaces: availableSpaces,
        occupancy_rate: occupancyRate,
        created_at: new Date().toISOString(),
        totalSpaces,
        occupiedSpaces,
        availableSpaces,
        occupancyRate
      };
      
      console.log("Calculated screen data to add:", fullScreenData);
      
      await addScreenToSupabase(fullScreenData);
      toast.success("Pantalla añadida con éxito");
      await refreshData();
    } catch (err) {
      console.error("Error in addScreen:", err);
      toast.error(`Error al añadir pantalla: ${err instanceof Error ? err.message : String(err)}`);
    } finally {
      setIsLoading(false);
    }
  };

  const updateScreen = async (screenData: Screen) => {
    setIsLoading(true);
    try {
      console.log("Starting to update screen:", screenData);
      
      // Ensure we have proper numeric values
      const totalSpaces = Number(screenData.totalSpaces);
      const occupiedSpaces = Number(screenData.occupiedSpaces);
      
      // Calculate derived values
      const availableSpaces = totalSpaces - occupiedSpaces;
      const occupancyRate = totalSpaces > 0 ? Math.round((occupiedSpaces / totalSpaces) * 100) : 0;

      await updateScreenInSupabase({
        ...screenData,
        totalSpaces,
        occupiedSpaces,
        availableSpaces,
        occupancyRate,
      });
      
      toast.success("Pantalla actualizada con éxito");
      await refreshData();
    } catch (err) {
      console.error("Error in updateScreen:", err);
      toast.error(`Error al actualizar pantalla: ${err instanceof Error ? err.message : String(err)}`);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteScreen = async (screenId: string) => {
    setIsLoading(true);
    try {
      console.log("Starting to delete screen:", screenId);
      await deleteScreenFromSupabase(screenId);
      toast.success("Pantalla eliminada con éxito");
      await refreshData();
    } catch (err) {
      console.error("Error in deleteScreen:", err);
      toast.error(`Error al eliminar pantalla: ${err instanceof Error ? err.message : String(err)}`);
    } finally {
      setIsLoading(false);
    }
  };

  return { addScreen, updateScreen, deleteScreen };
};
